/* src/routes/blog/auto-bed-levelling.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import Gallery from "../../../_components/Gallery.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import Vimeo from "../../../_components/Vimeo.svelte.js";
import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";

function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("Johan's (jcrocholl) Github branch");
		},
		l(nodes) {
			t = claim_text(nodes, "Johan's (jcrocholl) Github branch");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (28:2) <Callout>
function create_default_slot_1(ctx) {
	let t0;
	let linkexternal;
	let t1;
	let br;
	let current;

	linkexternal = new LinkExternal({
			props: {
				href: "https://github.com/jcrocholl/Marlin/tree/fsr",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("Code can be found at\n    ");
			create_component(linkexternal.$$.fragment);
			t1 = space();
			br = element("br");
		},
		l(nodes) {
			t0 = claim_text(nodes, "Code can be found at\n    ");
			claim_component(linkexternal.$$.fragment, nodes);
			t1 = claim_space(nodes);
			br = claim_element(nodes, "BR", {});
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(linkexternal, target, anchor);
			insert(target, t1, anchor);
			insert(target, br, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal_changes = {};

			if (dirty & /*$$scope*/ 8) {
				linkexternal_changes.$$scope = { dirty, ctx };
			}

			linkexternal.$set(linkexternal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(linkexternal, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(br);
		}
	};
}

// (23:0) <PostContents>
function create_default_slot(ctx) {
	let t0;
	let vimeo;
	let t1;
	let callout;
	let t2;
	let gallery;
	let current;
	vimeo = new Vimeo({ props: { id: "98630132" } });

	callout = new Callout({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	gallery = new Gallery({
			props: { images: /*photos_auto_leveling*/ ctx[2] }
		});

	return {
		c() {
			t0 = text("Video of the G29 (Auto level) command.\n  ");
			create_component(vimeo.$$.fragment);
			t1 = text("\n  This process involves using 3 Force Sense Resistors (FSR's) in order to use\n  the actual print head as the z-probe.\n  ");
			create_component(callout.$$.fragment);
			t2 = text("\n  Here are some images of how the sensors are attached to the printer (under\n  the bed):\n  ");
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "Video of the G29 (Auto level) command.\n  ");
			claim_component(vimeo.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n  This process involves using 3 Force Sense Resistors (FSR's) in order to use\n  the actual print head as the z-probe.\n  ");
			claim_component(callout.$$.fragment, nodes);
			t2 = claim_text(nodes, "\n  Here are some images of how the sensors are attached to the printer (under\n  the bed):\n  ");
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(vimeo, target, anchor);
			insert(target, t1, anchor);
			mount_component(callout, target, anchor);
			insert(target, t2, anchor);
			mount_component(gallery, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const callout_changes = {};

			if (dirty & /*$$scope*/ 8) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
		},
		i(local) {
			if (current) return;
			transition_in(vimeo.$$.fragment, local);
			transition_in(callout.$$.fragment, local);
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(vimeo.$$.fragment, local);
			transition_out(callout.$$.fragment, local);
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(vimeo, detaching);
			if (detaching) detach(t1);
			destroy_component(callout, detaching);
			if (detaching) detach(t2);
			destroy_component(gallery, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 8) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "3D Printer 4 - Auto Bed Levelling";
const date = "2014-06-19 13:43:03";

function instance($$self) {
	const tags = ["hardware"];
	const projects = ["3D-Printer"];

	const photos_auto_leveling = [
		"/content/blog/images/auto-bed-levelling/fsr_a.jpg",
		"/content/blog/images/auto-bed-levelling/fsr_b.jpg",
		"/content/blog/images/auto-bed-levelling/electronics_a.jpg",
		"/content/blog/images/auto-bed-levelling/electronics_b.jpg"
	];

	return [tags, projects, photos_auto_leveling];
}

class Auto_bed_levelling extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Auto_bed_levelling;
//# sourceMappingURL=auto-bed-levelling.svelte.js.map
